/* eslint-disable no-use-before-define */
import _ from 'underscore';
import { useEffect } from 'react';
import { useTelemetry } from '../use-telemetry';

export default function useErrorLogs(...errors) {
  const { error: log } = useTelemetry();
  const logObjects = _.map(errors, error => (_.isArray(error) && error.length === 2
    ? { data: error[0], source: error[1] }
    : { data: error }));

  const argsOverflowError = errors.length > 5 ? { data: `Too many errors to log (max:5, actual:${errors.length})` } : undefined;
  useJsonLog(log, argsOverflowError);

  // fake looping with hooks...
  useJsonLog(log, logObjects[0]);
  useJsonLog(log, logObjects[1]);
  useJsonLog(log, logObjects[2]);
  useJsonLog(log, logObjects[3]);
  useJsonLog(log, logObjects[4]);
}

function useJsonLog(log, { data, source = '' } = {}) {
  useEffect(() => {
    if (data != null) {
      log(source + JSON.stringify(data));
    }
  }, [source, data, log]);
}
